import { Box, Card, CardBody, Heading, SimpleGrid, Text } from '@chakra-ui/react'
import type { DashboardFunnelStat } from './types'

type DashboardFunnelSectionProps = {
  title: string
  items: DashboardFunnelStat[]
  cardBg: string
  textColor: string
  subtitleColor: string
  statNumberColor: string
  borderColor: string
}

export function DashboardFunnelSection(props: DashboardFunnelSectionProps) {
  const {
    title,
    items,
    cardBg,
    textColor,
    subtitleColor,
    statNumberColor,
    borderColor,
  } = props

  return (
    <Card
      bg={cardBg}
      borderRadius="xl"
      boxShadow="sm"
    >
      <CardBody p={{ base: 4, md: 6 }}>
        <Heading size={{ base: 'sm', md: 'md' }} mb={4} color={textColor}>
          {title}
        </Heading>
        <SimpleGrid columns={{ base: 1, sm: 2, xl: 4 }} spacing={{ base: 3, md: 4 }}>
          {items.map((item) => (
            <Box
              key={item.label}
              borderWidth="1px"
              borderColor={borderColor}
              borderRadius="lg"
              p={{ base: 3, md: 3.5 }}
            >
              <Text fontSize="sm" color={subtitleColor}>
                {item.label}
              </Text>
              <Text fontSize="2xl" fontWeight="bold" color={statNumberColor} mt={2}>
                {item.value}
              </Text>
            </Box>
          ))}
        </SimpleGrid>
      </CardBody>
    </Card>
  )
}
